import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '../components/ProtectedRoute';
import { Loader } from '../components';

import { AUTH_ROUTE_TYPE, ONLY_CLIENTS_ROUTE_TYPE } from '../constants/routeTypes';
import { CotizationPage } from '../containers/main/pages/CotizacionPage';
import CreateAccountPage from '../containers/main/pages/CreateAccountPage';
import { MainLayout } from '../containers/main/layouts';
import MainRoutes from '../containers/main/router/MainRoutes';

import { CheckTokenUrl } from '../middlewares/CheckTokenUrl';
import ChiploRoutes from '../containers/Chiplo/router/ChiploRoutes';
import AgentRoutes from '../containers/agente/router/AgentRoutes';
import {
  AGENTE_LOGIN_ROUTE,
  AVISO_PRIVACIDAD_ROUTE,
  CIFRAS_INMOBILIARIA_ID,
  LOGIN_ROUTE,
  PAPER_BACKGROUND,
  WALL_OF_LOVE_ROUTE,
} from '../constants';

import InfonavitRoutes from '../containers/Infonavit/router/InfonavitRoutes';
import LiquidezRoutes from '../containers/Liquidez/router/LiquidezRoutes';
import ViviendaRoutes from '../containers/Vivienda/router/ViviendaRoutes';
import { CreateAccountProvider } from '../context/createAccount';
import EntityRoutes from '../containers/entity/router/EntityRoutes';
import { WallOfLovePage } from '../containers/WallOfLove';
import { PerfiladorProvider } from '../context/perfilador';
import { TabsProvider } from '../context/tabs/tabsProvider';
import { LandingProvider } from '../context/landing';
import Landing from '../containers/landing';
import { AvisoPrivacidad } from '../containers/landing/sections/AvisoPrivacidad';
import { LandingLayout } from '../containers/landing/layouts/LandingLayout';
import { HeaderBar } from '../containers/landing/components/HeaderBar';
import TitulaYaPage from '../containers/TitulaYa';

// eslint-disable-next-line arrow-body-style
export const AppRouter = () => {
  return (
    <Routes>
      <Route
        path="/cotizacion"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/account"
            additionalData={{ authProtected: false }}
          >
            <MainLayout
              backgroundColorKey={PAPER_BACKGROUND}
            >
              <CotizationPage />
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/account"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/main/consult"
            additionalData={{ authProtected: false }}
          >
            <MainLayout>
              <CreateAccountProvider>
                <CreateAccountPage />
              </CreateAccountProvider>
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/main/*"
        element={(
          <CheckTokenUrl>
            <ProtectedRoute
              type={AUTH_ROUTE_TYPE}
              redirectPath={LOGIN_ROUTE}
              additionalData={{ authProtected: true, path: '/main/*' }}
            >
              <ProtectedRoute
                type={ONLY_CLIENTS_ROUTE_TYPE}
                redirectPath={AGENTE_LOGIN_ROUTE}
                additionalData={{ authProtected: true }}
              >
                <Suspense fallback={<Loader />}>
                  <MainRoutes />
                </Suspense>
              </ProtectedRoute>
            </ProtectedRoute>
          </CheckTokenUrl>
        )}
      />
      <Route
        path="/vivienda/*"
        element={(
          <CheckTokenUrl>
            <ViviendaRoutes />
          </CheckTokenUrl>
        )}
      />
      <Route
        path="/liquidez/*"
        element={(
          <CheckTokenUrl>
            <LiquidezRoutes />
          </CheckTokenUrl>
        )}
      />
      <Route
        path="/agente/*"
        element={<AgentRoutes />}
      />
      <Route
        path="/inmobiliaria/*"
        element={(
          <PerfiladorProvider>
            <EntityRoutes />
          </PerfiladorProvider>
        )}
      />
      <Route
        path="/infonavit/*"
        element={<InfonavitRoutes />}
      />
      <Route
        path={WALL_OF_LOVE_ROUTE}
        element={(
          <LandingProvider>
            <MainLayout
              showStepperBar={false}
              displayAuthUser={false}
              navigateOnLogoClick
            >
              <WallOfLovePage />
            </MainLayout>
          </LandingProvider>
        )}
      />
      <Route
        path="/cifras"
        element={(
          <LandingProvider inmobiliariaId={CIFRAS_INMOBILIARIA_ID}>
            <TabsProvider>
              <Landing />
            </TabsProvider>
          </LandingProvider>
        )}
      />
      <Route
        path={AVISO_PRIVACIDAD_ROUTE}
        element={(
          <LandingProvider>
            <TabsProvider>
              <LandingLayout
                showStepperBar={false}
                displayAuthUser={false}
                navigateOnLogoClick
              >
                <HeaderBar
                  navigateOnLogoClick
                />
                <AvisoPrivacidad />
              </LandingLayout>
            </TabsProvider>
          </LandingProvider>
        )}
      />
      <Route path="/titulaya" element={<TitulaYaPage />} />
      <Route
        path="/*"
        element={(
          <Suspense fallback={<Loader />}>
            <ChiploRoutes />
          </Suspense>
        )}
      />
    </Routes>
  );
};
